import moment from 'moment';

export default function getMonthDayFormatInUserLocale(date: Date | string, language: string): string {
  if (language === 'zht') {
    return moment(date).format('MMM Do');
  }
  return moment(date).format('MMM DD');
}
